// the css is injected automatically
require('!style-loader!css-loader!postcss-loader!stylus-loader!./contacttime.styl');

// this helps us remove everything exepct whats inside the body node
var strip = require("striphtml");
var dropdown = require("../dropdown/dropdown");
var getData = require('../../scripts/getdata')(MBGF.mbfa_apibase);
var parsing = require('parsing').contacttime;

var dataSource = "";

function parse(text, next) {
    strip(require('raw!./contacttime.html'), function(outputHtml) {
        var match = parsing.parse(text);

        var options;

        if (match) {

            var that = this;

            getData('contacttime', function (jsonString) {
                // check if the datasource is to be overridden
                if (that.dataSource && that.dataSource != "") {
                    jsonString = that.dataSource;
                }

                try {
                    if (typeof jsonString == "object") {
                        options = jsonString;
                    }
                    else {
                        options = JSON.parse(jsonString);
                    }
                }

                catch (e) {
                    options = false;
                }

                var insertOptions = "";
                if (options) {
                    var array = [];
                    for (var i = 0; i < options.length; i++) {
                        array[i] = options[i].value + " -> " + options[i].label;

                        if (options[i].selected) {
                            array[i] = "(" + array[i] + ")";
                        }
                    }
                    insertOptions = array.join(",");
                }

                outputHtml = outputHtml.replace("{}", "{" + insertOptions + "}");

                if (match[1] == "*") {
                    var container = document.createElement("div");
                    container.innerHTML = outputHtml;
                    var domObj = container.firstChild;

                    // add a "required" class to the parent node
                    domObj.setAttribute("class", domObj.getAttribute("class") + " required");
                    domObj.setAttribute("data-required", "true");

                    outputHtml = container.innerHTML.replace("= {", "* = {");
                }

                text = text.replace(match[0], outputHtml);
                next(text);
            });
        }
        else {
            next(text);
        }
    });
};

function validate(context, err) {
    var ok = dropdown.validate(context);

    return ok;
}

function get(context) {
    var value = dropdown.get(context);

    return value;
}

function reset(context) {
    dropdown.reset(context);
}

module.exports = {
    parse: parse,
    validate: validate,
    dataSource: dataSource,
    get: get,
    reset: reset
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/contacttime/contacttime.js